import { UrlQueryOperator } from '/@/modules/core/app/constants/UrlQueryOperator';
import { BaseModel } from '/@/modules/core/app/models/abstracts/BaseModel';

export class TableFilter extends BaseModel {
  /**
   * @var {string}
   */
  columnField;

  /**
   * @var {TableColumn}
   */
  column;

  /**
   * @var {?string}
   */
  operator;

  /**
   * @var {any}
   */
  value;

  /**
   * This is used when we need a selection from the user
   * Ex: selecting a range of values for 'between'
   * @var {?string}
   */
  secondValue;

  /**
   * @var {CustomTableFilter}
   */
  customTableFilter;

  constructor(model = {}) {
    super();

    this.columnField = model.columnField;
    this.column = model.column;
    this.operator = model.operator ?? null;
    this.value = model.value ?? null;
    this.secondValue = model.secondValue ?? null;
    this.customTableFilter = model.customTableFilter ?? null;
  }

  /**
   * @return {string}
   */
  get id() {
    return this.column?.field;
  }

  /**
   * @return {boolean}
   */
  get isCustom() {
    return !!this.customTableFilter;
  }

  /**
   * @returns {string}
   */
  get trackBy() {
    return this.column.customTableFilter?.config?.trackBy ?? 'key';
  }

  /**
   * @param {?any} value
   */
  setValue(value) {
    this.value = UrlQueryOperator.isOperatorMultiple(this.operator)
      ? value?.map((val) => val[this.trackBy])
      : value;
  }

  /**
   * @param {TableColumn} column
   * @param {boolean} canUnselect
   */
  setColumn(column, canUnselect = true) {
    this.column = column;

    if (canUnselect) {
      this.unsetSelections();
    }

    if (column.customTableFilter) {
      this.customTableFilter = column.customTableFilter;
    }
  }

  unsetSelections() {
    this.value = null;
    this.secondValue = null;
    this.operator = null;
    this.customTableFilter = null;
  }

  /**
   * @return {string}
   */
  calculateValue() {
    return UrlQueryOperator.buildQueryParam(this.operator, this.value, this.secondValue);
  }
}
